import Tabby from "tabbyjs";
import Swiper from "swiper";
import { Autoplay, EffectFade, Pagination } from "swiper/modules";

function resetSwiperPagination(swiper) {
    swiper.pagination.bullets.forEach(bullet => {
        const progress = bullet.querySelector("i");

        if (progress) {
            progress.style.width = "0%";
        }
    });
}

function updateSwiperPagination(swiper) {
    resetSwiperPagination(swiper);

    const activeProgress = swiper.pagination.bullets[swiper.realIndex]?.querySelector("i");

    if (activeProgress) {
        activeProgress.style.width = "100%";
    }
}

function initializeSwiper(container, pagination) {
    return new Swiper(container, {
        modules: [Autoplay, Pagination, EffectFade],
        rewind: true,
        effect: "fade",
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        },
        pagination: {
            el: pagination,
            clickable: true,
            renderBullet: (_index, className) => `<span class="${className}"><i></i></span>`,
        },
        on: {
            init() {
                updateSwiperPagination(this);
            },
            slideChangeTransitionStart() {
                updateSwiperPagination(this);
            },
            autoplayTimeLeft(swiper, _time, progress) {
                const activeProgress = swiper.pagination.bullets[swiper.realIndex]?.querySelector("i");

                if (activeProgress) {
                    activeProgress.style.width = `${progress * 100}%`;
                }
            },
        },
    });
}

function setActivePagination(showcase, tabId) {
    showcase.querySelectorAll("[data-pagination-for]").forEach(pagination => {
        pagination.classList.toggle("is-active", pagination.dataset.paginationFor === tabId);
    });
}

function initializeFixedTabs(showcase, tablet, holder, pagination) {
    let frame = null;

    const absoluteBottom = parseFloat(window.getComputedStyle(holder).bottom) || 0;
    const overlap = pagination.offsetHeight;
    const baseFixedBottom = absoluteBottom - overlap;

    const update = () => {
        frame = null;

        const tabletRect = tablet.getBoundingClientRect();
        const showcaseRect = showcase.getBoundingClientRect();
        const cookieOffset = parseFloat(
            window.getComputedStyle(document.documentElement).getPropertyValue("--cookie-consent-height")
        ) || 0;
        const fixedBottom = baseFixedBottom + cookieOffset;
        const fixedTop = window.innerHeight - fixedBottom - holder.offsetHeight;
        const naturalTop = showcaseRect.bottom - absoluteBottom - holder.offsetHeight;
        const shouldFix = tabletRect.top < fixedTop && naturalTop > fixedTop;

        holder.classList.toggle("is-fixed", shouldFix);
    };

    const requestUpdate = () => {
        if (frame === null) {
            frame = window.requestAnimationFrame(update);
        }
    };

    window.addEventListener("scroll", requestUpdate, { passive: true });
    window.addEventListener("resize", requestUpdate);
    window.addEventListener("cookieconsent:resize", requestUpdate);
    update();
}

document.addEventListener("DOMContentLoaded", () => {
    if (!window.matchMedia("(min-width: 769px)").matches) {
        return;
    }

    const showcase = document.querySelector(".promo__showcase");
    const tablet = showcase?.querySelector(".promo__tablet");
    const tabsElement = showcase?.querySelector("[data-tabs]");
    const tabsHolder = showcase?.querySelector(".tabs__holder");
    const paginationHolder = showcase?.querySelector(".promo__pagination");
    const swiperElements = showcase?.querySelectorAll(".swiper");

    if (!showcase || !tablet || !tabsElement || !tabsHolder || !paginationHolder || !swiperElements?.length) {
        return;
    }

    new Tabby("[data-tabs]");

    swiperElements.forEach(container => {
        const pane = container.closest(".tabs__pane");
        const pagination = showcase.querySelector(`[data-pagination-for="${pane?.id}"]`);

        if (pagination) {
            initializeSwiper(container, pagination);
        }
    });

    const activateTab = tabLink => {
        const tabId = tabLink.getAttribute("href").slice(1);
        const target = document.getElementById(tabId);
        const activeSwiper = target?.querySelector(".swiper")?.swiper;

        swiperElements.forEach(container => {
            if (container.swiper) {
                container.swiper.autoplay.stop();
                container.swiper.slideTo(0, 0);
                updateSwiperPagination(container.swiper);
            }
        });

        setActivePagination(showcase, tabId);
        activeSwiper?.update();
        activeSwiper?.autoplay.start();
    };

    tabsElement.querySelectorAll("a").forEach(tabLink => {
        tabLink.addEventListener("click", () => activateTab(tabLink));
    });

    const activeTab = tabsElement.querySelector("a[aria-selected=\"true\"]");

    if (activeTab) {
        activateTab(activeTab);
    }

    initializeFixedTabs(showcase, tablet, tabsHolder, paginationHolder);
});
